import { render, staticRenderFns } from "./NavigationPagev3.vue?vue&type=template&id=66525ae0&scoped=true&"
import script from "./NavigationPagev3.vue?vue&type=script&lang=js&"
export * from "./NavigationPagev3.vue?vue&type=script&lang=js&"
import style0 from "./NavigationPagev3.vue?vue&type=style&index=0&id=66525ae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66525ae0",
  null
  
)

export default component.exports